import I18n from 'I18n';
const regexNonAlphabeticalCharacters = /[^a-zA-Z0-9 ]/g;
const regexOnlyNumericalCharacters = /^\d+$/g;

//TODO: Explore other cases to display participant names
/*
 * Names from other languages, how to display initials
 */

export function getParticipantInitials(name) {
  const initials = name.replace(regexNonAlphabeticalCharacters, '').split(' ').map(t => {
    regexOnlyNumericalCharacters.lastIndex = 0;
    if (t.length > 1 && regexOnlyNumericalCharacters.test(t)) {
      return t.substring(0, 2);
    }
    return t[0];
  });
  return initials.join('').substring(0, 3);
}
export function getParticipantNotAvailableName(speaker) {
  if (speaker.mappedSpeakerTrackId) {
    return I18n.text('recordingReviewComponents.transcript.speakerName', {
      speakerTrackId: speaker.mappedSpeakerTrackId
    });
  } else {
    return I18n.text('recordingReviewComponents.media.mediaTimeline.speaker.nameNotAvailable');
  }
}
export function getParticipantDomainFromEmail(email) {
  const parts = email.split('@');
  if (parts.length > 1) {
    return parts[1];
  } else {
    throw new Error('Invalid email format');
  }
}